// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
app-root .biz-flow header.pseudo-header {
  margin: 0 -16px;
  left: 16px;
  width: 100%;
  min-width: 320px;
  position: fixed;
}
app-root .lf-flow header.pseudo-header {
  margin: 0 -16px;
  left: 16px;
  width: 100%;
  min-width: 320px;
  position: fixed;
}
@media (min-width: 1151px) {
  app-root .lf-flow header.pseudo-header {
    width: 66%;
  }
}
app-root header.pseudo-header {
  padding: 12px 40px;
  position: fixed;
  max-height: 64px;
  top: 0;
  z-index: 20;
  box-sizing: border-box;
  background-color: white;
  border-bottom: 1px solid var(--header-border);
}
app-root header.pseudo-header a {
  display: inline-block;
}
app-root header.pseudo-header a .logo {
  display: inline-block;
  width: 200px;
  height: auto;
  color: var(--primary);
}
@media (max-width: 599px) {
  app-root header.pseudo-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
  }
  app-root header.pseudo-header a {
    flex: none;
  }
  app-root header.pseudo-header a .logo {
    width: 120px;
  }
}
app-root aside.process-section {
  display: none;
  visibility: hidden;
}
@media (min-width: 1151px) {
  app-root aside.process-section {
    visibility: visible;
    display: inline-flex;
    flex-direction: column;
    overflow-y: auto;
    z-index: 20;
    position: fixed;
    top: 0;
    right: 0;
    transform-origin: right;
    height: 100%;
    width: 34%;
    padding: 64px 16px;
    vertical-align: top;
    background: linear-gradient(142.83deg, #af231c 15.51%, #230706 100%);
  }
  app-root aside.process-section > * {
    margin: auto;
  }
  app-root aside.process-section .process-wrapper {
    position: relative;
    width: 75%;
    max-width: 25rem;
  }
  app-root aside.process-section .process-wrapper * {
    text-align: center;
  }
  app-root aside.process-section .bold-white-top {
    color: #fff;
    text-align: center;
    font-family: Montserrat;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    padding-bottom: 24px;
    text-wrap: pretty;
  }
}
app-root main.error-oage + aside.process-section {
  display: none;
  visibility: hidden;
}
@media (min-width: 1151px) {
  app-root .pseudo-header::before,
  app-root progress.form-progress::before,
  app-root nav.form-nav::before {
    content: '';
    display: block;
    position: absolute;
    width: 51.5151%;
    top: 0;
    left: 100%;
    height: 100%;
  }
  app-root .pseudo-header::before,
  app-root nav.form-nav::before {
    background-color: white;
  }
  app-root .pseudo-header::before {
    border-bottom: 1px solid #f5f5f5;
  }
  app-root nav.form-nav::before {
    border-top: 1px solid #f5f5f5;
  }
  app-root progress.form-progress::before {
    background-color: #bfbfbf;
  }
  app-root progress.form-progress[value='100']::before {
    background-color: #af231c;
  }
  app-root .biz-login-banner::before {
    border-top: 1px solid #d9d9d9;
    background-color: #f0f0f0;
  }
  app-root .pseudo-header::before,
  app-root nav.form-nav::before,
  app-root .biz-login-banner::before {
    height: calc(100% + 1px);
  }
  app-root nav.form-nav::before,
  app-root .biz-login-banner::before {
    top: unset;
    bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Components/Brand/Messaging/LeadFeed/Aside/Aside.less","webpack://./src/Components/PseudoHeader/PseudoHeader.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;ACLA;EF+BE,eAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;ACvBF;ACZA;EF+BE,eAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AChBF;ADoDE;EAAA;IACE,UAAA;ECjDF;AACF;ACxBA;EASI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;EAEA,uBAAA;EACA,6CAAA;ADiBJ;AClCA;EAoBM,qBAAA;ADiBN;ACrCA;EAsBQ,qBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;ADkBR;ACbI;EAAA;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,SAAA;IACA,kBAAA;EDgBJ;ECrBE;IAQI,UAAA;EDgBN;ECxBE;IAUM,YAAA;EDiBR;AACF;AAxDA;EAEI,aAAA;EACA,kBAAA;AAyDJ;AAvDI;EAAA;IACE,mBAAA;IACA,oBAAA;IACA,sBAAA;IACA,gBAAA;IACA,WAAA;IAOA,eAAA;IACA,MAAA;IACA,QAAA;IACA,uBAAA;IACA,YAAA;IACA,UAAA;IACA,kBAAA;IACA,mBAAA;IACA,oEAAA;EAoDJ;EAxEE;IASI,YAAA;EAkEN;EA3EE;IAuBI,kBAAA;IACA,UAAA;IACA,gBAAA;EAuDN;EAhFE;IA4BM,kBAAA;EAuDR;EAnFE;IAiCI,WAAA;IACA,kBAAA;IACA,uBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,oBAAA;IACA,iBAAA;EAqDN;AACF;AAnGA;EAmDI,aAAA;EACA,kBAAA;AAmDJ;AAhDE;EAAA;;;IAMI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,eAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;EAgDJ;EA5DA;;IAiBI,uBAAA;EA+CJ;EAhEA;IAoBI,gCAAA;EA+CJ;EAnEA;IAuBI,6BAAA;EA+CJ;EAtEA;IA2BI,yBAAA;EA8CJ;EAzEA;IA8BI,yBAAA;EA8CJ;EA5EA;IAkCI,6BAAA;IACA,yBAAA;EA6CJ;EAhFA;;;IAyCI,wBAAA;EA4CJ;EArFA;;IA6CI,UAAA;IACA,SAAA;EA4CJ;AACF","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../../../../Styles/colours.less';\n@import '../../../../../Styles/utilities.less';\n@import '../../../../../Styles/mediaQueries.less';\n@import '../../../../PseudoHeader/PseudoHeader.less';\n\napp-root {\n  aside.process-section {\n    display: none;\n    visibility: hidden;\n\n    @media @desktopUp {\n      visibility: visible;\n      display: inline-flex;\n      flex-direction: column;\n      overflow-y: auto;\n      z-index: 20;\n\n      > * {\n        // essential for overflow-ready centering\n        margin: auto;\n      }\n\n      position: fixed;\n      top: 0;\n      right: 0;\n      transform-origin: right;\n      height: 100%;\n      width: 34%;\n      padding: @pseudo-header-height 16px;\n      vertical-align: top;\n      background: linear-gradient(142.83deg, @primary 15.51%, #230706 100%);\n\n      .process-wrapper {\n        position: relative;\n        width: 75%;\n        max-width: 25rem;\n\n        * {\n          text-align: center;\n        }\n      }\n\n      .bold-white-top {\n        color: #fff;\n        text-align: center;\n        font-family: Montserrat;\n        font-size: 22px;\n        font-style: normal;\n        font-weight: 600;\n        padding-bottom: 24px;\n        text-wrap: pretty;\n      }\n    }\n  }\n\n  main.error-oage + aside.process-section {\n    display: none;\n    visibility: hidden;\n  }\n\n  @media @desktopUp {\n    // Pseudo-content extends the visible header and footer behind the aside to prevent visible gaps\n    // during entrance and exit\n    .pseudo-header::before,\n    progress.form-progress::before,\n    nav.form-nav::before {\n      content: '';\n      display: block;\n      position: absolute;\n      width: 51.5151%; // evaluates to ~ 34% of the full screen width\n      top: 0;\n      left: 100%;\n      height: 100%;\n    }\n\n    .pseudo-header::before,\n    nav.form-nav::before {\n      background-color: white;\n    }\n    .pseudo-header::before {\n      border-bottom: 1px solid @header-border;\n    }\n    nav.form-nav::before {\n      border-top: 1px solid @header-border;\n    }\n\n    progress.form-progress::before {\n      background-color: @faint-grey;\n    }\n    progress.form-progress[value='100']::before {\n      background-color: @primary;\n    }\n\n    .biz-login-banner::before {\n      border-top: 1px solid #d9d9d9;\n      background-color: @input-background-grey;\n    }\n\n    .pseudo-header::before,\n    nav.form-nav::before,\n    .biz-login-banner::before {\n      height: calc(100% + 1px); // border height otherwise excluded\n    }\n    nav.form-nav::before,\n    .biz-login-banner::before {\n      top: unset;\n      bottom: 0;\n    }\n  }\n}\n","@import '../../Styles/mediaQueries';\n@import '../../Styles/utilities';\n\napp-root {\n  .biz-flow header.pseudo-header {\n    .fixed-full-width-content();\n  }\n  .lf-flow header.pseudo-header {\n    .fixed-two-third-width-content();\n  }\n\n  header.pseudo-header {\n    padding: 12px 40px;\n    position: fixed;\n    max-height: @pseudo-header-height;\n    top: 0;\n    z-index: 20;\n    box-sizing: border-box;\n\n    background-color: white;\n    border-bottom: 1px solid var(--header-border);\n\n    a {\n      display: inline-block;\n      .logo {\n        display: inline-block;\n        width: 200px;\n        height: auto;\n        color: var(--primary);\n      }\n    }\n\n    // On phones the logo and the sign-in prompt share one row, so they can't overlap\n    @media @mobile {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 12px;\n      padding: 12px @body-gutter-width;\n\n      a {\n        flex: none;\n        .logo {\n          width: 120px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
